const narrowQuery = '(max-width: 650px)'

const sourceFor = (video) => {
	const narrowSrc = video.dataset.srcNarrow
	const useNarrow = narrowSrc && window.matchMedia(narrowQuery).matches
	return useNarrow ? narrowSrc : video.dataset.src
}

export const initWideVideo = () => {
	const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches

	document.querySelectorAll('[data-wide-video]').forEach((root) => {
		if (root.dataset.wideVideoReady === 'true') return
		root.dataset.wideVideoReady = 'true'

		const video = root.querySelector('video')
		const button = root.querySelector('[data-wide-video-toggle]')
		if (!video || !button || !video.dataset.src) return

		const setLabel = (playing) => {
			button.textContent = playing ? 'Pause' : 'Play'
		}

		const play = () => {
			const nextSrc = sourceFor(video)
			if (video.getAttribute('src') !== nextSrc) {
				video.src = nextSrc
			}
			video.muted = true
			const pending = video.play()
			if (pending && typeof pending.catch === 'function') {
				pending.catch(() => setLabel(false))
			}
		}

		button.addEventListener('click', () => {
			if (video.paused) {
				play()
			} else {
				video.pause()
			}
		})

		video.addEventListener('play', () => setLabel(true))
		video.addEventListener('pause', () => setLabel(false))

		if (reduceMotion) {
			video.pause()
			setLabel(false)
			return
		}

		play()
	})
}
